module.exports = __webpack_public_path__ + "img/IMG_9181-224_L_Wood.7f40298f.jpg";